<template>
  <div class="donation-bankaccount-v2-overlay" @click.self="close">
    <div class="donation-bankaccount-v2-modal">
      <span @click="close" class="donation-bankaccount-v2-modal__close"
        >&times;</span
      >
      <div v-if="error" class="donation-bankaccount-v2-modal__error">
        {{ error }}
      </div>
      <div id="bank-account-iframe-v2"></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'BankAccountV2',

  props: {
    wpAjax: {
      type: String,
      required: true,
    },
    nonce: {
      type: String,
      required: true,
    },
    socialsecuritynumber: {
      type: String,
      default: null,
    },
    colorTheme: {
      type: String,
      default: 'light',
    },
  },

  data() {
    return {
      client: null,
      error: null,
    };
  },

  mounted() {
    this.loadScript('https://accountlookup.billecta.com/js/client.js')
      .then(() => this.initiate())
      .catch(() => {
        this.error = 'Kunde inte ladda bankkontouppslag.';
      });
  },

  beforeDestroy() {
    if (this.client) {
      const client = this.client;
      this.client = null;
      client.stop();
    }
  },

  methods: {
    close() {
      if (this.client) {
        const client = this.client;
        this.client = null;
        client.stop();
      }
      this.$emit('close');
    },

    loadScript(src) {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },

    initiate() {
      const data = new FormData();
      data.append('action', 'initiate_account_lookup');
      data.append('nonce', this.nonce);
      if (this.socialsecuritynumber) {
        data.append('socialsecuritynumber', this.socialsecuritynumber);
      }
      axios
        .post(this.wpAjax, data)
        .then((response) => {
          const { sessionToken, sessionId } = response.data;
          if (!sessionToken || !sessionId) {
            this.error = 'Kunde inte starta bankkontouppslag.';
            return;
          }
          this.startWidget(sessionToken, sessionId);
        })
        .catch(() => {
          this.error = 'Kunde inte starta bankkontouppslag.';
        });
    },

    startWidget(sessionToken, sessionId) {
      // eslint-disable-next-line no-undef
      this.client = new Billecta(sessionToken, sessionId);
      this.client.start({
        selector: '#bank-account-iframe-v2',
        colorTheme: this.colorTheme,
        onSuccessful: (data) => {
          if (data.accountNo && data.clearingNo) {
            this.$emit('select', {
              AccountNo: data.accountNo,
              ClearingNo: data.clearingNo,
            });
          }
          this.close();
        },
        onAborted: () => {
          this.close();
        },
        onFailed: (data) => {
          this.error = data.errorMessage || 'Bankkontouppslag misslyckades.';
        },
      });
    },
  },
};
</script>

<style lang="scss">
.donation-bankaccount-v2-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.donation-bankaccount-v2-modal {
  position: relative;
  background-color: #fff;
  border-radius: 8px;
  padding: 24px 16px 16px;
  width: 430px;
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;

  &__close {
    position: absolute;
    top: 4px;
    right: 15px;
    font-size: 28px;
    cursor: pointer;
    color: #000;
    line-height: 1;
  }

  &__error {
    color: red;
    text-align: center;
    padding: 12px 0;
    font-size: 14px;
  }
}
</style>
